export function insertBody(parent: HTMLElement, ...childs: Array<HTMLElement>) {
	const firstChild = parent.firstElementChild;
	const lastChild = parent.lastElementChild;
	parent.innerHTML = '';
	parent.appendChild(firstChild);
	for (let i = 0; i < childs.length; i++) {
		parent.appendChild(childs[i]);
	}
	parent.appendChild(lastChild);
}

export function getWindowWidth() {
	return window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
}

export function getWindowHeight() {
	return window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;
}
